<!-- Video Section Start -->
<section class="cyclops video-section text-center">
  <div class="container">
    <h2 class="section-title gradient-text text-left" style="color: #b70000;">Above All – Beyond Limit</h2>
    <div class="video-wrapper mt-4">
      <video 
        class="video-element" 
        playsinline 
        controls
        >
        <source src="assets/images/DARK PHOENIX INSTR 1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>
